import * as React from 'react'

import { SectionLayout } from './styles'

export const Left: React.FC<{ children?: React.ReactNode }> = ({ children, ...rest }) => (
  <SectionLayout role='region' aria-label='Left Site Header' location='left' {...rest}>
    {children}
  </SectionLayout>
)
